module.exports = __webpack_public_path__ + "media/images/city/093-london-eye-4d8d5a9a5365b3cd8d12d65fbdc56fee.svg";